import { useMemo } from 'react';

import { EditorialQueuePage } from '@/types/resources';

import useNetwork from './useNetwork';

const useQueueSettings = (activePage?: EditorialQueuePage) => {
  const [network] = useNetwork();

  const settings = useMemo(() => {
    return activePage?.settings.find((s) => s.network === network);
  }, [activePage?.settings, network]);

  return settings;
};

export default useQueueSettings;
